export default "__VITE_ASSET__DpMjaa9p__"